
var newfont = {
  "selection": [
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    },
    {
      "order": 0
    }
  ],
  "metadata": {
    "name": "Untitled Set 2",
    "importSize": {
      "width": 300,
      "height": 450
    },
    "iconsHash": 416677776
  },
  "height": 1024,
  "prevSize": 32,
  "icons": [
    {
      "paths": [
        "M579.488 1000.612l-140.602-0.407-25.894-152.585-143.235-0.669-25.96 153.254h-140.62l168.013-976.816h140.072l168.225 977.224zM389.229 712.285l-48.003-283.734-48.051 283.084 96.053 0.651z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_a"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M473.554 23.388l88.986 96.738v345.887l-44.69 46.956 44.69 42.148v361.736l-78.889 83.756h-363.525v-977.221h353.428zM260.16 580.394v273.601h161.826v-273.601h-161.826zM260.178 438.126h161.826v-266.857h-161.826v266.857z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_b"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M465.283 23.388h-247.874l-96.67 101.565-0.036 774.098 93.732 101.56h251.488l96.038-101.037v-104.901h-141.76l-0.25 57.328-157.211 0.335 0.553-681.488 156.13 0.353 0.036 57.558h142.507v-103.806z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_c"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M314.216 470.141v45.716h22.851l-15.239 38.077h30.477l15.226-38.077v-45.716z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_comma"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M467.26 23.388l95.755 101.581-0.048 773.937-95.196 101.585-348.121 0.121v-977.028l347.609-0.196zM422.079 852.123v-680.373h-160.7v680.373h160.7z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_d"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M291.986 491.226h99.032v45.695h-99.032v-45.695z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_dash"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M317.886 535.582h47.029v-47.161h-47.163z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_dot"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M119.856 23.388v977.224h442.345l-0.162-146.12h-300.571v-249.355h166.243l0.36-147.747h-166.603l0.034-286.7h301.306v-147.301z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_e"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M120.143 23.388v977.224h141.856v-392.187h167.274v-148.029h-167.274v-289.442h300.526v-147.565z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_f"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M215.902 23.388l-95.698 101.103-0.052 774.697 96.299 101.424h250.3l95.728-101.424v-439.428h-191.973v147.495h50.941v244.486h-160.263v-680.505h168.227l-0.28 60.318h133.384v-107.063l-95.733-101.103z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_g"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M120.379 23.388v977.226l140.773-0.036v-415.419l160.52-0.314v415.733h140.616v-977.19h-140.616v414.604l-160.52-0.357v-414.247z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_h"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M270.766 23.475v977.137h141.135v-977.224z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_i"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M421.49 23.388v827.729h-159.71v-83.376h-142.161v130.392l95.589 102.48 252.254-0.355 95.585-101.745v-875.124z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_j"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M410.499 23.388l-149.65 336.416 0.644-336.416h-141.342v976.96l141.043 0.246 0.125-295.731 49.466-112.412 105.766 408.162 145.963-0.264-162.174-606.809 162.038-369.816z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_k"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M120.156 23.388v977.224h442.354v-146.68h-300.842v-830.544z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_l"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M231.893 23.388h-140.538v977.205l141.171-0.371v-505.81l108.899 353.947 108.879-351.011v503.264l141.009-0.018v-977.205h-140.991l-108.897 378.632z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_m"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M261.191 23.827h-140.871v976.784l140.816-0.146 0.496-517.325 159.318 517.325h141.396v-977.078h-140.62l0.146 521.289z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_n"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M466.578 23.866l95.614 100.573v775.118l-96.472 101.053-248.891-0.496-96.354-101.071v-774.604l94.060-101.051 252.043 0.478zM261.309 170.953v682.050h159.906v-682.050h-159.906z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_o"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M467.024 23.388l95.428 100.752-0.030 355.515-95.655 101.16-205.879 0.048v419.744l-140.673-0.335v-976.885h346.808zM260.924 434.438l160.754 0.191v-264.558h-161.068l0.314 264.367z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_p"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M340.717 489.845c-8.611 0-16.020 4.283-20.332 11.742-4.303 7.452-4.303 16.018 0 23.477 4.312 7.443 11.719 11.733 20.332 11.733 8.599 0 16.027-4.289 20.328-11.733 4.308-7.459 4.308-16.024 0-23.484-4.301-7.452-11.726-11.735-20.328-11.735z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_period"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M548.268 118.661l-0.048 723.426-50.222 75.585 14.325 34.136-121.635 48.802-23.179-63.75-142.821 0.166-90.287-94.615 0.055-724.082 90.249-94.943h233.804l89.759 95.275zM266.065 161.401v638.264h53.758l-12.083-27.12 108.831-45.668 0.027-565.476h-150.533z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_q"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M466.96 23.388l95.758 101.39-0.587 345.989-83.661 99.672 83.595 429.837-140.065 0.335-86.81-428.544h-73.594v428.546l-141.647-0.335v-976.889h347.011zM261.632 425.67h159.214v-261.27h-159.81l0.596 261.27z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_r"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M215.784 23.761l-95.63 96.652v377.608l96.763 86.032h204.484v268.618l-161.278 0.357v-51.43h-139.988v97.942l96.782 101.071h249.424l96.19-101.426v-361.010l-96.174-101.001-205.637-0.371 0.011-265.462h159.535v51.057l141.699 0.339v-99.075l-96.174-100.275z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_s"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M232.273 363.62l233.784-0.416v60.869l163.128-2.551v-139.467l-127.595-87.079-325.525 0.826-122.584 85.404v461.166l121.76 85.816 325.464 0.837 128.48-86.653-1.242-142.013-173.338 0.389v60.455h-222.331z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_small_c"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M51.689 171.195v682.726l575.704-1.42v-177.382h-388.683v-74.998h245.146v-175.618h-245.146v-72.711h387.322v-180.597z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_small_e"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M120.020 23.388l0.35 146.434h150.166v830.789l140.891-0.191v-830.598h151.222l-0.027-146.434z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_t"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M120.154 23.388v874.778l96.807 102.446h248.532l97.021-102.147v-875.058h-140.422v836.126h-160.172v-836.144z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_u"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M119.94 23.388l151.356 977.224h140.818l150.61-976.691h-140.44l-80.32 501.76-79.506-501.76z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_v"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M80.243 23.388l59.253 977.224h141.581l60.505-279.425 59.312 279.425 141.576-0.73 59.954-976.154-141.596-0.339-28.18 443.529-91.596-437.289-92.463 437.696-26.137-443.936z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_w"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M120.224 23.745l150.023 487.035-149.802 489.424 141.282 0.407 79.314-238.21 80.302 237.873 140.418-0.071-149.408-488.045 150.089-488.398-141.041-0.373-79.829 239.589-81.54-239.589z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_x"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M119.756 23.955l151.165 669.421v307.236h141.43v-307.236l150.56-669.987-139.492 0.303-81.294 333.373-81.271-333.373z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_y"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M120.249 23.388l-0.598 148.257 288.486 0.441-287.746 680.132v148.394h442.625v-148.86l-289.944 0.394 289.919-680.5-0.369-148.257z"
      ],
      "attrs": [
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_z"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M356.354 244.242c5.946 26.563 9.421 49.662 11.544 76.777l3.361 69.766 1.070 87.204v87.133l-3.113 69.596c-1.757 36.129-6.538 66.954-15.804 101.965-3.377 11.193-7.523 20.407-13.683 30.367-3.222 4.988-7.111 8.597-12.374 11.469-6.19-26.613-9.894-49.757-12.29-76.952l-3.691-78.079-0.985-66.196 0.332-85.759 0.489-19.538 4.831-82.029c2.872-28.545 6.97-52.832 13.694-80.746 2.831-10.215 6.137-18.728 10.97-28.18 3.231-7.498 8.354-12.98 15.649-16.798zM570.432 830.669c11.603-25.723 20.025-48.399 28.026-75.416l15.97-62.974 10.415-64.43 3.432-44.733c1.527-36.602 1.154-68.007-1.238-104.564l-5.318-59.501c-6.376-45.554-16.013-84.020-31.881-127.251-15.33-42.171-32.893-76.773-57.917-114.167l-14.498-18.903c-10.465-13.1-20.384-23.586-32.936-34.782-9.53-12.884-18.186-23.543-28.84-35.531-7.539-7.839-14.302-14.272-22.526-21.397-24.587-20.935-50.424-33.63-82.179-40.38-28.897-5.095-54.834-3.55-82.91 4.931-47.773 20.246-84.061 48.824-114.622 90.276-15.196 20.878-26.776 39.802-38.427 62.81-17.324 35.979-28.988 68.294-38.577 106.983-19.611 82.598-26.153 155.821-21.477 240.528 2.972 36.145 6.961 66.986 13.285 102.709 8.499 41.481 18.512 76.452 33.257 116.19 12.468 31.607 25.884 57.64 44.405 86.228 7.134 10.643 13.653 19.483 21.713 29.473 9.635 11.159 18.546 20.186 29.564 30.024 8.335 12.249 16.277 22.191 26.396 33.039 17.096 18.4 34.045 32.113 55.701 45.047 18.409 10.929 35.769 17.729 56.771 22.223 22.098 4.765 42.039 4.694 64.077-0.266 26.198-6.219 47.53-16.384 68.742-32.768 17.763-14.407 31.717-28.265 46.205-45.868 22.508-28.586 39.244-55.027 55.387-87.529z",
        "M361.178 703.736c-2.644 14.543-5.816 26.849-10.556 40.86-3.058 8.185-6.381 14.932-10.982 22.385-3.65 6.021-8.711 10.126-15.401 12.509-6.752 1.5-13.237 0.014-18.605-4.283-6.046-5.184-10.276-10.702-13.678-17.852-4.49-9.771-7.632-18.45-10.399-28.824-6.574-26.92-10.411-50.415-12.789-77.99l-3.68-79.371-1.067-66.212 0.332-85.741 0.473-19.545 4.845-82.032c2.872-28.581 6.988-52.879 13.676-80.83 3.263-12.256 7.584-22.376 14.179-33.266 3.47-6.738 9.35-11.132 16.878-12.586 5.819-0.426 10.952 0.762 15.97 3.707 8.515 7.311 14.222 15.419 18.202 25.837 4.066 10.681 6.947 20.059 9.573 31.166 4.656 24.055 7.532 44.869 9.594 69.286l3.443 69.83 1.047 87.133v87.117l-3.099 69.591c-1.661 24.303-4.046 45.061-7.955 69.111zM524.063 778.436c11.664-25.727 20.12-48.44 28.101-75.503l15.902-63.051 10.32-64.264 3.52-44.735c1.611-36.625 1.267-68.064-1.158-104.648l-5.395-59.499c-6.178-45.584-15.826-84.075-31.876-127.256-15.433-42.116-32.957-76.7-57.838-114.167-18.846-26.949-38.612-47.621-64.808-67.743-45.015-33.526-99.044-42.739-152.879-26.082-47.78 20.268-84.066 48.868-114.627 90.36-15.205 20.867-26.797 39.754-38.496 62.721-17.171 36.038-28.813 68.349-38.518 106.997-16.782 70.46-23.611 132.619-22.519 204.996 1.167 77.763 11.847 144.32 35.062 218.654 12.035 37.656 25.652 68.892 45.067 103.433 13.037 22.039 26.121 39.815 43.329 58.855 17.094 18.45 34.088 32.172 55.806 45.049 23.456 14.022 46.257 21.777 73.473 25.040 22.016 1.75 41.226-0.405 62.277-6.956 20.098-7.484 36.425-16.275 53.669-28.895 17.765-14.4 31.721-28.267 46.207-45.871 22.526-28.529 39.267-54.961 55.38-87.434z",
        "M288.013 791.099c-13.107-14.577-21.306-29.805-26.214-48.674-5.637-20.102-9.232-37.638-11.949-58.3l-4.995-49.184-3.206-112.228v-112.305l2.956-61.203c1.923-35.487 5.687-65.784 12.529-100.68 2.81-12.775 5.941-23.55 10.399-35.854 3.8-10.324 8.256-18.735 14.664-27.694 8.128-11.849 20.737-18.355 35.246-18.173 15.663 0.207 29.095 7.214 38.079 19.875 11.428 16.373 18.452 32.338 22.79 51.742 4.977 21.367 8.106 39.902 10.408 61.699l4.005 49.411 2.13 107.941 0.093 107.964-2.223 56.841c-1.595 33.621-4.947 62.325-11.125 95.439-4.185 23.39-11.412 42.84-23.532 63.381-6.868 11.487-17.028 18.958-30.149 22.193-14.95 2.84-29.202-1.497-39.906-12.192zM540.681 658.53c11.933-50.834 17.79-95.366 19.424-147.52l-0.162-50.226-8.763-104.553-10.738-51.268-17.538-56.111c-11.294-30.301-23.060-55.505-39.069-83.661-17.947-31.155-37.795-55.401-64.894-79.278-21.54-18.473-44.209-29.723-72.085-35.772-24.986-4.426-47.413-3.138-71.689 4.116-43.338 18.767-76.245 44.838-104.145 82.521-14.352 19.52-25.24 37.264-36.115 58.86-16.254 34.422-27.341 65.224-36.714 102.059l-8.028 36.17-10.32 73.316-3.6 72.103 2.355 67.98 6.815 54.495c6.742 40.048 14.875 73.944 27.027 112.729 9.51 28.647 19.679 52.545 33.765 79.278 13.617 25.213 27.896 45.472 47.102 66.867 15.56 16.675 30.961 29.123 50.631 40.851 20.573 12.486 40.678 19.374 64.651 22.205 18.862 1.779 35.421-0.084 53.407-5.982 20.842-7.418 37.563-17.023 54.406-31.241 20.571-17.938 36.24-35.537 51.614-57.97 15.856-23.62 28.008-44.767 40.396-70.34 13.358-34.199 23.054-64.13 32.267-99.628z"
      ],
      "attrs": [
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(142, 117, 52)"
        },
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor": true,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_0"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 0
          },
          {
            "f": 1
          },
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M455.134 23.561h-276.66l61.781 130.949-0.091 797.612 48.654 48.49h215.372v-928.98z",
        "M454.64 951.141l0.494-927.753h-276.5l61.531 131.609v796.144z",
        "M430.603 48.001l-0.501 878.612h-165.415v-777.082l-47.504-101.531z"
      ],
      "attrs": [
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(142, 117, 52)"
        },
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor": true,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_1"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 0
          },
          {
            "f": 1
          },
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M486.391 101.137c-11.837-15.267-23.356-27.284-38.118-39.752-15.517-12.743-30.668-21.452-49.487-28.481-18.996-6.638-36.302-9.5-56.42-9.321-21.097 0.503-39.115 3.598-59.16 10.149-32.29 10.192-58.029 25.391-82.537 48.754l-12.848 13.41-100.279 124.341 67.823 91.038 48.328 50.401 35.503-36.73 42.050-40.243c7.771-7.311 15.956-12.019 26.176-15.055 4.394 10.798 7.116 20.478 8.993 31.978 2.474 15.826 3.907 29.487 4.754 45.482 1.447 44.050-8.263 82.371-30.524 120.409l-8.413 13.26-206.479 303.643-0.653 167.201 47.536 47.935 484.336 1.056 0.824-197.782-49.826-49.983-163.196-0.501 121.824-157.864c6.888-9.068 12.42-17.105 18.466-26.749 30.602-51.407 47.73-101.023 55.398-160.324 7.869-59.886 3.73-112.806-13.337-170.726-16.534-55.583-45.643-99.087-90.736-135.546z",
        "M498.342 117.744c-12.957-19.631-26.264-35.021-43.852-50.64-17.117-16.084-34.609-26.968-56.589-35.255-34.561-10.479-66.856-11.2-101.847-2.285-33.899 8.754-61.285 23.154-87.691 46.128-7.901 7.1-14.277 13.624-21.199 21.681l-99.706 123.030 68.221 91.689c26.679-29.341 50.968-53.162 80.823-79.255 5.605-4.567 11.057-7.705 17.836-10.222 6.078-0.869 11.599 0.35 16.759 3.673 19.793 13.376 32.93 30.736 40.412 53.416l2.865 9.175c2.489 13.185 4.146 24.574 5.475 37.94 1.126 13.348 1.563 24.81 1.481 38.195-0.901 18.459-3.472 34.186-8.52 51.953-6.708 20.999-14.693 38.295-26.319 57.025l-24.794 37.699-186.186 273.137-0.639 166.791 483.098 0.573v-199.102l-249.81-0.903 132.349-168.339 31.33-42.384c26.203-37.064 43.741-72.381 57.437-115.662 6.385-22.066 10.34-41.406 13.078-64.205 2.64-30.74 3.099-57.214 1.563-88.025-2.328-30.781-6.651-56.978-14.329-86.867-7.971-25.357-17.447-46.26-31.246-68.963z",
        "M422.102 71.359c44.612 33.275 72.92 75.69 86.553 129.654 15.965 66.89 17.133 127.397 3.764 194.849-9.912 41.681-24.38 76.029-47.293 112.242-14.256 21.961-27.286 40.225-43.42 60.851l-162.791 207.041 275.087 0.899v151.24l-435.013-0.564 0.583-135.373 197.373-289.817 18.009-29.619c21.224-37.13 30.866-74.051 30.499-116.809-0.212-15.401-1.12-28.574-3.020-43.857-1.693-17.235-5.038-31.844-11.048-48.092-10.092-25.129-25.723-44.021-48.49-58.657-14.445-9.389-31.846-9.83-46.719-1.138-12.568 7.705-22.576 15.553-33.050 25.923l-45.001 45.411-40.325-54.488 87.871-108.387 10.051-11.203c15.244-15.196 30.533-26.041 49.898-35.421 28.836-14.065 56.72-19.822 88.765-18.32 25.425 1.252 47.022 8.806 67.718 23.634z"
      ],
      "attrs": [
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(142, 117, 52)"
        },
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor": true,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_2"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 0
          },
          {
            "f": 1
          },
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M412.388 964.082c27.261-11.664 49.703-23.802 74.379-40.23 16.236-11.585 29.050-23.004 42.448-37.758 26.239-30.506 42.045-62.594 50.258-101.97 4.738-23.343 7.054-43.686 7.614-67.493-1.675-20.792-4.248-38.521-8.52-58.946-3.254-13.455-6.879-24.767-12.063-37.592-8.952-20.767-19.315-37.412-34.004-54.597-13.783-15.333-26.565-27.584-42.444-40.723l-18.805-21.099c38.261-29.291 63.477-64.696 78.671-110.428 6.808-21.24 11.41-39.831 15.253-61.811 2.053-28.793 1.422-53.619-2.134-82.261-4.547-30.766-14.181-56.368-31.032-82.516-9.312-13.712-18.457-24.672-30.292-36.284-8.934-8.476-16.916-15.376-26.597-22.988-4.239-6.579-8.458-11.831-13.961-17.401-9.596-9.412-18.173-17.096-28.565-25.607-27.354-18.047-53.573-29.359-85.474-36.869-30.174-5.272-56.834-5.48-87.104-0.66-19.545 2.528-36.038 6.711-54.424 13.804-15.144 5.1-27.714 10.65-41.706 18.384-27.534 16.311-48.549 34.755-68.303 59.934l55.18 75.692 47.684 47.78c11.182-8.829 21.167-15.852 33.246-23.402 9.068-5.543 17.672-8.959 28.076-11.157 10.39-2.041 19.868-1.095 29.648 2.949 2.421 0.997 4.435 1.984 6.724 3.277l4.437 10.597c14.953 42.835 12.265 85.311-7.964 125.929-7.512 15.406-15.738 27.734-27.095 40.564-6.813 6.501-13.253 11.467-21.263 16.416-11.123 6.574-21.47 10.852-33.976 14.038-13.346 2.831-24.929 4.519-38.523 5.586l0.906 83.153 46.965 50.663c17.872 0.116 33.2 1.65 50.734 5.102 10.643 2.546 19.47 5.962 29.059 11.237 21.047 42.33 28.101 84.318 22.077 131.193-4.44 25.272-11.983 46.301-24.615 68.626-11.467 19.39-24.913 33.933-43.354 46.883-18.985 12.563-37.519 19.995-59.929 24.048l-13.703 1.984-69.061 2.048 0.164 100.9 46.401 47.443c45.379 0.489 84.268-1.065 129.47-5.17 45.076-5.475 83.147-14.973 125.517-31.268z",
        "M205.999 845.535c-9.871 2.351-18.466 3.759-28.56 4.674l-66.437 1.884v99.18c50.551 3.224 94.151 1.44 144.252-5.916l49.334-10.836 48.538-14.281 30.454-12.648c23.964-11.951 43.609-23.952 65.199-39.815 13.373-10.845 24.084-21.056 35.533-33.906 27.418-31.305 43.884-64.553 52.133-105.34 4.173-26.228 4.742-49.204 1.8-75.601-4.16-29.569-10.836-54.481-21.982-82.177-21.365-49.1-55.387-84.717-103.463-108.289 20.96-14.111 37.221-28.781 53.382-48.192 15.952-19.547 26.658-38.775 34.871-62.641 8.902-27.275 13.537-51.648 15.267-80.282 1.17-17.777 1.179-33.055 0.089-50.829-1.436-13.774-3.573-25.495-7.059-38.903-9.61-38.86-27.138-70.044-55.337-98.438-32.734-31.598-69.637-49.882-114.595-56.823-46.688-6.483-88.216-2.219-132.59 13.635-23.174 8.333-42.148 18.029-62.482 31.937-19.065 13.988-33.822 28.183-48.522 46.713l54.754 74.795 29.236-21.352c8.065-5.15 15.603-8.592 24.794-11.328 18.009-4.258 35.166-1.224 50.642 8.943 29.83 18.883 47.953 47.316 52.456 82.346 7.384 48.387-4.524 93.002-35.044 131.284-10.709 13.2-22.492 22.48-37.854 29.792-7.726 3.689-14.668 6.169-22.979 8.203-13.826 2.842-25.782 4.694-39.811 6.158l1.133 84.316c19.426 0.744 36.022 3.188 54.852 8.055 17.319 5.236 31.262 12.898 44.99 24.71 12.782 12.315 22.030 24.697 30.208 40.466 10.966 23.652 16.782 45.623 18.96 71.582 4.892 46.012-4.405 87.152-28.57 126.598-21.283 32.081-50.31 52.727-87.595 62.325z",
        "M344.986 897.661c-34.311 11.175-64.369 18.707-99.904 25.042-18.066 2.681-33.646 4.258-51.896 5.257l-58.359 0.162v-52.634c16.22 0.118 30.128-0.398 46.301-1.718 14.686-1.267 27.145-3.732 41.215-8.135 30.558-9.971 54.586-25.607 76.104-49.496 12.7-14.725 21.675-29.038 29.377-46.892 9.155-22.398 14.791-42.514 18.632-66.405 1.768-27.052 0.346-50.451-4.672-77.091-5.436-27.562-14.875-50.317-30.536-73.646-27.432-38.466-67.386-60.134-114.604-62.139l-0.58-41.709c25.611-2.344 47.136-10.117 68.303-24.71 21.675-16.159 36.896-34.661 48.599-59.021 23.882-47.302 27.42-96.827 10.518-147.037-12.388-33.865-34.975-58.778-67.488-74.374-16.288-7.842-32.522-10.090-50.313-6.991-19.201 3.973-34.921 11.341-50.267 23.563l-29.125-39.733c17.692-20.091 36.425-34.258 60.578-45.807 31.403-15.169 60.81-23.192 95.569-26.112 28.274-2.362 52.923 0.036 80.211 7.796 24.742 8.067 44.71 18.978 64.849 35.476 17.968 15.258 30.822 31.384 41.706 52.295 13.121 25.975 20.373 50.299 23.636 79.221 0.983 28.777-0.325 53.501-4.351 82.016-4.010 24.253-10.743 44.521-22.075 66.332-11.635 20.976-24.794 37.242-42.853 53.032-21.258 17.736-41.477 30.547-66.587 42.207 27.405 7.753 49.814 18.248 73.316 34.309 20.867 14.873 36.268 31.196 49.921 52.886 16.955 29.013 26.915 56.632 32.342 89.793 5.484 31.623 4.822 59.731-2.125 91.052-10.631 40.819-30.267 73.284-61.497 101.642-31.842 28.246-63.868 47.22-103.945 61.57z"
      ],
      "attrs": [
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(142, 117, 52)"
        },
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor": true,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_3"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 0
          },
          {
            "f": 1
          },
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M568.361 750.683h69.106l0.573-144.957-50.042-50.049-19.638-0.077v-482.909l-48.476-49.045-135.116 0.972-340.143 597.235v78.884l49.134 49.464 218.897 0.894v199.402l49.948 50.115h204.773z",
        "M312.24 542.399h-68.613l68.783-120.19-0.171 120.19zM517.926 951.148l0.983-250.17 69.502-0.583v-145.042l-70.001-0.887 0.573-531.078-134.374 0.894-339.984 597.413v78.388l268.033 0.978v249.271l205.266 0.815z",
        "M337.176 329.792l-0.398 237.136h-135.355l135.753-237.136zM563.96 676.047v-96.495l-70.001-0.881 0.578-530.584-95.592 0.567-329.785 579.468v47.591l268.015 0.988v249.271l156.381 0.573 0.983-249.845 69.42-0.653z"
      ],
      "attrs": [
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(142, 117, 52)"
        },
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor": true,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_4"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 0
          },
          {
            "f": 1
          },
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M464.889 888.889c24.13-20.25 43.16-39.565 63.076-63.977 19.035-24.171 32.342-47.277 43.675-75.876 11.33-30.103 16.721-57.587 17.613-89.723l-0.164-19.888c-2.694-21.028-6.249-38.869-11.817-59.331-7.018-23.511-16.796-42.592-31.778-62.011l-15.080-17.868-38.147-38.050c-7.129-9.362-13.854-16.926-22.328-25.108-8.297-7.518-15.76-13.569-24.854-20.123-30.356-20.974-59.799-34.111-95.68-42.694-8.565-1.779-15.984-2.91-24.685-3.748l-60.32-0.733 0.571-104.562h248.486l61.608-193.559-47.6-47.755-423.358-0.414v513.352l46.601 47.989 151.356 1.063c8.706 18.99 12.183 37.183 11.064 58.027-1.516 27.896-8.169 51.578-21.347 76.211-17.479 30.954-36.024 55.494-61.028 80.757-18.382 18.314-37.433 30.788-61.545 40.343-8.877 3.149-16.807 5.015-26.162 6.185-17.362 0.696-32.279 0.569-49.63-0.398l1.067 103.979 47.593 49.634 58.839-0.567 36.584-5.036c37.335-7.261 68.649-16.88 103.59-31.876 46.173-20.867 83.643-43.349 123.799-74.245z",
        "M336.279 893.144c35.597-18.974 64.357-38.486 95.116-64.571 25.259-21.895 44.435-43.566 63.076-71.295 36.222-54.927 50.813-113.32 44.742-178.815-2.99-19.679-6.915-36.32-13.039-55.241-5.969-15.549-12.37-28.351-21.195-42.473-18.35-28.995-39.444-50.549-68.048-69.516-29.405-19.388-57.986-31.041-92.57-37.724l-18.669-3.256-109.868-1.229 0.341-152.974h248.957l60.311-192.255-421.422-0.405v513.349h137.642c8.39 0.419 15.528 2.417 22.903 6.44 16.737 9.965 28.403 23.213 36.184 41.065 9.564 20.753 13.476 40.587 12.563 63.424-1.343 16.184-4.101 29.928-9.13 45.393-5.73 14.072-11.51 25.773-19.242 38.866-13.287 20.287-25.768 36.946-41.474 55.417-8.146 8.959-15.569 16.236-24.694 24.207-18.512 16.236-37.683 26.506-61.445 32.925-8.595 2.043-16.118 3.065-24.945 3.35-13.499 0.339-25.072 0.114-38.543-0.751l0.73 104.489c42.068 2.055 78.404-0.988 119.558-10.015 44.678-11.501 81.738-26.196 122.159-48.403z",
        "M344.515 860.943l-53.064 27.946c-18.685 8.554-35.098 15.007-54.607 21.504-40.095 12.682-76.265 18.002-118.32 17.449l-0.419-55.826c30.72 1.752 57.64-4.517 84.428-19.627 17.551-10.169 31.428-20.867 45.716-35.223 14.9-15.305 26.756-29.3 39.378-46.526 17.026-22.257 28.963-43.386 39.281-69.439 7.459-20.915 10.738-39.975 10.677-62.173-0.193-25.407-5.557-47.209-17.201-69.78-9.685-19.192-22.517-33.462-40.573-45.136-10.838-6.84-21.641-10.358-34.402-11.25l-117.275-0.171v-465.176l364.615 0.405-45.306 144.093h-255.249l-0.492 200.884 132.014 1.388c30.167 4.142 55.435 12.229 82.407 26.308 56.026 29.883 92.449 78.197 105.791 140.274 10.702 56.272 3.124 108.048-23.245 158.904-15.417 29.152-32.529 52.117-56.063 75.225-27.996 26.597-54.682 46.56-88.091 65.946z"
      ],
      "attrs": [
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(142, 117, 52)"
        },
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor": true,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_5"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 0
          },
          {
            "f": 1
          },
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M423.31 991.389c-45.814 13.744-89.404 12.149-134.080-4.945-27.093-10.845-48.781-24.032-70.895-43.074l-14.042-12.648c-10.222-10.015-18.559-19.021-27.739-30.010-14.042-11.505-25.113-22.514-36.659-36.514-15.936-19.761-27.755-38.195-39.103-60.912-14.511-30.342-24.335-57.594-32.513-90.208-6.276-27.207-10.015-50.881-12.427-78.684l-0.89-54.911c1.104-38.004 3.989-70.515 9.564-108.137 12.39-74.998 31.175-137.96 61.895-207.492l24.096-49.803 26.035-41.606c15.237-21.647 29.336-39.422 46.895-59.217 17.702-19.058 34.497-33.853 55.649-48.997 23.943-16.775 47.031-27.584 75.269-35.201 38.655-9.271 74.392-7.163 111.698 6.554l48.105 46.726 20.109 92.39c-21.852-1.729-40.851-0.168-62.118 5.12-20.177 5.703-36.27 15.128-51.116 29.93-13.674 14.568-23.691 28.683-32.939 46.387-15.927 33.043-27.496 62.339-38.446 97.353 52.124-0.455 97.262 15.080 138.058 47.536 13.476 11.137 23.725 22.291 33.669 36.655 12.336 9.958 22.282 19.228 33.091 30.825l13.544 16.307c17.342 24.15 29.198 47.031 38.939 75.118l7.223 21.909c5.213 22.478 8.67 41.968 11.523 64.885 3.677 36.3 2.54 67.871-3.739 103.822-11.592 58.8-34.061 106.937-71.712 153.554-33.184 43.709-74.265 71.937-126.944 87.286zM326.055 814.226c3.982-1.531 6.959-4.041 9.166-7.687 3.229-5.243 5.404-10.099 7.225-15.988 4.738-17.108 7.491-32.122 9.164-49.803l2.999-40.955 0.482-82.104-3.482-55.494c-12.802 9.562-21.115 21.47-25.712 36.752-6.456 19.513-9.858 36.939-11.198 57.421-3.397 55.489 0.064 103.456 11.355 157.858z",
        "M97.31 797.275c-21.185-45.215-32.996-87.026-38.623-136.674l-3.818-67.821 2.678-68.046 8.688-67.566 14.359-66.346 24.499-76.268c19.376-51.273 40.368-93.559 69.52-139.988 26.528-39.037 54.095-69.225 90.515-99.214 14.864-11.519 28.365-20.355 44.869-29.371 17.447-9 33.492-14.682 52.731-18.655 16.043-3.625 30.31-4.631 46.717-3.24 19.963 1.632 36.894 5.22 55.81 11.844l19.215 88.983c-14.8-0.036-27.507 0.512-42.253 1.779-8.797 1.029-16.238 2.674-24.66 5.427-21.251 8.829-37.642 21.001-52.249 38.775-14.734 19.172-25.948 36.661-37.148 58.088l-26.358 74.777-19.788 76.659c32.932-24.64 71.332-32.627 111.368-23.192 51.368 10.272 92.515 35.237 125.322 76.076 33.66 50.797 51.457 101.922 56.609 162.648 2.637 30.775 2.417 57.36-0.721 88.107-3.932 30.010-10.372 55.351-21.238 83.624-18.98 44.669-42.496 79.97-76.418 114.688-31.978 30.242-65.934 49.484-108.294 61.392-34.686 9.107-66.478 9.56-101.394 1.475-44.451-11.414-80.106-31.523-112.845-63.679-23.659-26.79-40.994-52.365-57.094-84.284zM349.66 752.023l3.491-38.855 2.264-59.306c0.494-29.364-0.323-54.515-2.756-83.793l-3.989-24.412c-2.082-10.074-5.040-18.487-9.728-27.664-3.759-8.595-12.85-13.276-22.055-11.346-10.090 1.702-18.241 6.44-24.735 14.368-10.299 13.647-16.739 27.186-20.86 43.791-3.998 16.696-6.378 31.248-7.862 48.335l0.728 45.841 2.583 45.661c1.718 22.86 5.079 42.303 11.123 64.416 4.007 12.925 9.175 23.484 16.964 34.552 7.366 9.453 18.582 13.822 30.415 11.851 3.873-1.186 6.87-3.42 9.086-6.824 3.855-5.948 6.317-11.612 8.021-18.489 3.543-13.144 5.75-24.606 7.309-38.127z",
        "M360.455 810.831c-2.922 6.884-6.476 12.331-11.601 17.768-10.866 10.126-24.885 13.888-39.349 10.54-16.311-3.293-29.179-12.236-37.972-26.342-11.116-18.441-17.822-35.974-21.811-57.126-5.031-27.086-7.739-50.586-9.011-78.113l-1.286-65.308c1.092-13.676 2.681-25.35 5.266-38.846 4.226-22.187 11.244-40.585 22.869-59.947 9.223-14.782 22.107-24.499 38.862-29.28 8.922-2.383 17.076-2.624 26.123-0.824 7.184 1.946 12.93 5.286 18.166 10.554 5.484 5.88 9.332 11.717 12.579 19.074 4.808 11.221 7.864 21.299 10.037 33.328 4.139 26.028 6.098 48.597 6.501 74.952l-2.023 78.923c-1.44 27.568-3.732 51.116-7.625 78.454-2.569 11.489-5.5 21.19-9.726 32.192zM528.038 767.429c14.093-31.207 21.816-59.995 25.225-94.092 1.85-21.129 1.962-39.365 0.41-60.509-2.289-22.794-5.216-42.207-9.742-64.655-5.616-28.397-13.951-52.053-27.341-77.701-16.769-28.356-37.526-49.025-65.939-65.72-26.592-15.804-52.52-24.228-83.315-27.081-21.279-1.206-39.95 3.263-58.402 13.958-25.293 15.747-44.262 33.706-61.401 58.070 2.362-25.265 5.468-46.806 10.381-71.7l16.386-66.678c9.792-32.852 19.406-60.607 32.038-92.474l12.256-22.307c8.831-15.078 17.337-27.455 28.233-41.137 10.759-12.923 21.554-22.756 35.442-32.286 22.601-14.548 45.716-21.433 72.606-21.561l-10.16-46.649c-21.604-7.107-41.533-9.143-64.143-6.56-21.798 3.056-40.063 8.866-59.629 18.974-23.202 12.588-41.702 25.894-60.999 43.889-24.205 23.208-43.174 44.963-62.867 72.112-16.536 26.767-29.598 50.358-43.481 78.607-61.932 128.371-84.48 253.84-71.132 395.751 3.834 31.164 9.603 57.549 19.144 87.454 7.766 22.439 16.22 41.021 27.971 61.643 12.745 21.641 25.457 39.121 42.116 57.924 16.866 16.022 33.084 27.919 53.444 39.169 39.77 21.488 80.657 27.887 125.087 19.561 24.385-5.086 44.59-12.859 66.114-25.397 20.007-12.265 35.906-24.833 52.483-41.445 24.988-28.078 43.019-55.225 59.215-89.156z"
      ],
      "attrs": [
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(142, 117, 52)"
        },
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor": true,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_6"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 0
          },
          {
            "f": 1
          },
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M368.403 999.151l245.917-927.177-48.585-48.010-496.827-0.576-0.562 227.867 49.075 49.068h205.248l-209.322 649.434 49.236 50.854z",
        "M338.855 250.361h-270.020v-226.313l495.363 0.398-245.601 924.497-205.419 1.934z",
        "M299.709 924.444l232.664-875.5-438.973-0.412v177.175h279.397l-225.838 700.204z"
      ],
      "attrs": [
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(142, 117, 52)"
        },
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor": true,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_7"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 0
          },
          {
            "f": 1
          },
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M602.228 859.439c-15.144 30.272-32.991 53.819-58.033 76.572-43.893 37.754-92.24 58.118-149.9 63.147-29.323 2.813-54.823 1.582-83.747-4.050-26.974-4.781-49.507-12.397-73.869-24.967-21.832-12.079-39.221-24.892-57.23-42.173-10.829-10.652-19.527-20.355-28.936-32.27-12.295-9.109-22.143-17.854-32.609-29.038-9.849-10.909-17.545-20.953-25.518-33.316-19.895-33.043-31.243-64.903-36.73-103.076-4.936-39.656-4.196-74.304 2.428-113.712 10.804-65.641 42.132-118.716 94.379-159.901-15.588-14.363-27.91-27.782-40.88-44.535-10.272-13.986-17.406-27.179-23.493-43.42-5.652-16.209-8.886-30.649-10.652-47.714-1.88-20.18-2.644-37.542-2.517-57.797l2.831-25.534c6.021-41.818 18.873-76.686 41.467-112.412 17.82-27.072 38.118-47.072 65.438-64.542 30.137-18.22 59.153-28.704 93.967-33.981 20.084-2.658 37.467-3.645 57.717-3.24 21.183 2.030 39.203 5.35 59.742 10.957 28.424 8.413 51.291 21.022 73.566 40.571 15.638 14.411 28.135 27.712 41.549 44.23 12.814 9.817 23.149 19.101 34.297 30.797 10.336 11.050 18.355 21.286 26.578 33.974 18.25 29.136 28.781 57.408 34.058 91.382 4.867 33.605 4.867 63.033 0 96.652-3.29 24.647-9.974 45.315-21.782 67.218-15.11 25.2-31.293 44.91-53.080 64.635 41.845 33.655 68.99 73.801 84.626 125.178 7.568 25.641 11.678 48.351 13.558 75.025 1.431 27.775 0.862 51.671-1.859 79.34-5.602 27.559-13.296 50.597-25.368 76.001zM320.473 814.328c12.943-2.56 23.149-9.589 30.172-20.723 5.746-8.722 9.657-16.844 12.916-26.747 3.52-11.455 5.898-21.456 7.88-33.257 4.155-31.507 4.811-58.882 2.116-90.544-1.377-19.008-4.624-35.123-10.718-53.166-14.718 5.045-25.575 14.866-32.033 29.009-8.831 18.043-14.011 34.684-16.985 54.543-4.526 31.023-5.584 58.004-3.495 89.268 0.883 18.468 3.973 34.186 10.147 51.619zM325.86 392.686c10.097-3.318 17.72-9.546 22.992-18.776 6.551-11.453 10.686-22.15 13.492-35.037 9.23-44.264 9.086-83.998-0.489-128.191-9.234 1.263-16.723 5.967-21.873 13.724-7.766 11.908-12.429 23.44-15.114 37.406-3.98 20.817-5.846 38.953-6.176 60.145l0.737 29.109c0.801 14.752 2.726 27.307 6.431 41.62z",
        "M302.758 811.151c-8.745-5.15-14.969-11.858-19.424-20.981-8.879-18.539-14.279-35.512-17.806-55.749-3.174-18.78-4.756-35.037-5.202-54.054 0.212-18.496 1.409-34.299 3.984-52.604 2.455-18.072 6.54-33.294 13.494-50.16 4.251-11.2 10.097-20.023 18.78-28.272 6.435-5.534 13.712-8.276 22.196-8.385 7.605-0.259 14.263 2.064 20.075 6.986 7.482 6.931 12.764 14.122 17.142 23.343 12.484 31.585 18.437 60.571 19.426 94.531 1.686 33.592-1.463 62.664-10.32 95.098-3.62 13.135-8.577 23.902-16.186 35.21-5.004 7.204-11.043 12.206-19.085 15.774-9.114 3.388-18.161 3.149-27.075-0.737zM301.208 389.188c-7.462-5.561-12.538-12.17-16.002-20.817-4.872-10.836-7.978-20.596-10.245-32.263-7.011-38.939-7.348-73.373-1.145-112.426 2.624-16.455 7.2-30.208 14.96-44.954 4.467-8.738 11.867-14.511 21.468-16.653 13.835-2.881 27.234 1.759 36.334 12.588 10.861 16.25 16.741 32.522 18.771 51.94 4.754 35.237 4.569 66.034-0.562 101.212-2.931 20.002-9.582 36.598-21.306 53.082-10.306 12.716-27.914 16.17-42.273 8.29zM529.874 149.875c-13.54-25.816-28.809-46.060-49.91-66.175-17.645-16.646-35.082-28.526-57.060-38.853-20.992-9.441-40.041-15.151-62.758-18.782-21.886-2.241-40.792-2.681-62.742-1.454-17.824 2.037-32.959 4.71-50.406 8.852-12.022 3.873-22.139 7.666-33.737 12.688-48.67 21.791-83.982 55.524-107.948 103.149-14.668 29.698-22.999 57.303-27.225 90.155-3.732 28.667-3.98 53.619-0.831 82.339 3.821 29.437 12.211 54.040 27.161 79.672 14.088 21.761 28.868 38.698 48.531 55.605-37.795 28.506-63.402 62.302-80.643 106.391-10.436 28.121-16.011 53.501-18.286 83.395-2.332 29.789-1.732 55.508 2.032 85.117 11.457 84.849 60.302 152.847 137.041 190.787 18.983 8.608 35.833 14.68 55.94 20.171 21.973 4.667 41.117 7.12 63.552 8.199 34.142 0.512 63.506-4.212 95.771-15.376 67.070-23.29 116.859-66.94 148.749-130.378 12.511-26.724 19.793-51.25 23.916-80.47 3.554-38.316 2.194-71.594-4.492-109.497-5.22-31.421-14.020-57.694-28.763-85.936-17.014-29.405-36.441-51.874-63.074-72.984 33.287-26.044 54.636-57.952 65.998-98.686 7.466-26.629 10.795-50.301 10.968-77.949-0.899-24.342-3.593-45.152-8.863-68.927-6.16-22.027-13.055-40.425-22.922-61.051z",
        "M333.169 835.934c-12.557 3.9-24.526 3.561-36.825-1.049-13.205-5.86-22.976-14.554-30.326-26.979-10.604-17.834-17.167-34.65-21.449-54.955-4.271-20.314-6.663-37.974-7.974-58.684-2.596-44.157 2.972-82.55 18.052-124.143 5.591-14.675 13.041-26.278 24.055-37.456 10.666-10.115 23.188-15.335 37.879-15.776 12.149-0.728 22.847 2.148 33.002 8.852 10.923 7.887 18.694 16.937 24.792 28.941 8.033 15.886 13.21 30.397 17.001 47.791 3.984 19.408 6.315 36.256 7.719 56.015 3.516 43.961-1.402 82.389-15.842 124.052-4.904 12.937-10.984 23.334-19.836 33.976-8.301 9.698-17.972 15.908-30.247 19.415zM336.432 414.304c-11.699 3.689-22.619 4.128-34.57 1.384-11.724-3.454-20.869-9.796-28.208-19.583-9.639-13.674-15.674-26.993-19.583-43.251-4.016-17.064-6.306-31.953-7.632-49.414-1.431-21.845-1.217-40.648 0.724-62.437 1.873-20.371 5.561-37.647 12.192-56.996 4.501-12.242 10.44-22.009 19.267-31.605 8.697-8.822 18.967-13.701 31.284-14.88 20.669-2.737 39.747 4.319 53.658 19.838 7.332 8.829 12.306 17.497 16.263 28.278 5.138 14.397 8.178 27.25 10.001 42.428 3.147 28.847 3.591 53.819 1.454 82.757-1.347 16.343-4.066 30.217-9.013 45.855-4.198 13.567-9.607 24.66-17.722 36.327-7.093 10.361-16.213 17.285-28.114 21.299zM336.976 47.946c-25.516-1.186-47.514 0.617-72.501 5.928-22.312 5.22-40.787 12.447-60.728 23.739-37.654 22.551-63.973 52.247-81.854 92.342-12.754 29.186-19.447 56.111-21.848 87.857-1.192 16.411-1.374 30.513-0.587 46.917 1.026 14.702 3.131 27.236 6.991 41.442 6.422 22.649 15.713 41.024 30.149 59.606 16.928 20.924 34.092 36.741 56.347 51.855-0.53-0.114-1.054 0.134-1.286 0.63-0.237 0.496-0.118 1.065 0.305 1.397-11.621 7.086-21.19 13.824-31.771 22.362-9.66 8.101-17.479 15.59-26.023 24.867-11.815 13.517-20.623 26.285-29.107 42.096-19.083 38.537-27.88 75.451-28.21 118.447-0.366 21.497 0.471 39.911 2.769 61.301 2.394 15.178 5.441 28.028 10.172 42.678 9.466 27.709 21.948 50.035 40.553 72.656 23.714 27.689 49.541 46.87 82.919 61.542 33.084 13.967 63.761 20.598 99.656 21.55 65.575 1.502 122.746-19.861 171.274-63.991 48.676-44.897 74.017-101.872 74.7-168.095-0.193-30.727-2.719-57.025-8.363-87.231-4.446-21.798-10.631-40.025-20.328-60.063-9.846-19.101-20.662-34.277-35.521-49.826-16.923-17.067-33.073-30.017-53.407-42.84 43.873-21.57 73.462-57.155 86.651-104.234 15.392-56.074 12.941-108.772-7.557-163.203-15.776-43.379-40.737-76.67-77.961-103.979-32.456-22.494-65.98-33.858-105.433-35.751z"
      ],
      "attrs": [
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(142, 117, 52)"
        },
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor": true,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_8"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 0
          },
          {
            "f": 1
          },
          {
            "f": 2
          }
        ]
      }
    },
    {
      "paths": [
        "M424.191 53.983c21.932 13.094 39.419 26.506 57.754 44.278l21.418 23.088c13.763 11.432 24.908 22.043 37.023 35.237l15.444 18.794c28.934 39.458 46.601 78.686 56.944 126.512 5.043 24.264 8.301 45.245 10.904 69.885l3.507 96.893c-3.991 71.792-14.607 132.931-35.064 201.851-21.625 67.682-47.566 123.335-85.522 183.378-28.294 43.882-60.482 76.506-103.984 105.442-19.008 12.331-36.475 21.074-57.742 28.89-24.612 8.695-47.058 12.484-73.155 12.377-19.231-0.41-35.676-3.245-53.94-9.289l-47.029-47.677-22.533-89.245c23.836 0.278 44.337-3.097 66.79-11.071 18.951-7.252 33.929-16.871 48.415-31.064 16.327-16.819 27.989-33.496 38.168-54.609 13.599-29.762 23.074-56.293 31.389-87.943-39.306 0.908-73.371-7.373-107.895-26.26-15.756-8.492-28.356-17.51-41.481-29.714-9.28-8.927-16.27-17.59-23.022-28.547-15.986-11.674-28.597-23.206-41.654-38.072-23.252-27.75-38.061-55.976-47.666-90.883-10.563-42.164-15.342-79.385-15.776-122.862-0.014-78.466 22.922-146.193 70.601-208.516 23.060-29.405 47.507-51.027 79.487-70.374 32.090-18.666 63.374-28.351 100.409-31.077 43.236-0.403 80.566 9.255 118.211 30.579zM330.547 467.285c12.224-8.071 20.503-18.475 25.634-32.208 6.442-17.096 10.056-32.497 11.865-50.681 2.426-27.607 2.683-51.416 0.894-79.087-2.651-33.537-6.533-62.134-12.93-95.189-4.062 1.486-7.104 4.069-9.266 7.807-3.331 5.429-5.507 10.49-7.243 16.605-4.792 17.925-7.555 33.651-9.127 52.151l-2.838 42.708-0.414 84.53 3.425 53.364z",
        "M326.064 469.909c-4.374 2.323-8.495 3.618-13.41 4.221-3.55 0.571-6.783-0.027-9.855-1.873-6.868-6.114-11.207-13.155-13.574-22.059-4.285-13.717-6.845-25.823-8.479-40.095l-2.76-31.894-0.323-64.284 2.856-67.529c1.809-17.665 4.305-32.711 8.283-50.021 2.392-9.578 5.184-17.563 9.282-26.531 1.454-3.643 3.677-6.426 6.918-8.618 16.291-2.524 31.737 5.402 39.199 20.086 5.065 8.763 8.476 16.8 11.253 26.526 3.916 15.574 6.442 29.125 8.372 45.074l3.834 43.939 2.257 44.084c0.041 15.11-0.503 28.060-1.789 43.122-1.811 25.095-8.445 46.349-21.233 68.021-5.835 7.721-12.297 13.246-20.83 17.831zM441.433 826.516c30.568-42.027 52.857-80.855 73.801-128.412 21.843-50.674 36.329-95.926 48.012-149.857 10.734-61.47 15.269-114.954 14.948-177.37-0.942-45.117-6.119-83.711-17.158-127.477-8.201-27.291-17.023-50.117-29.282-75.837-8.684-15.635-16.789-28.626-27.027-43.274-26.984-34.755-57.244-59.189-96.886-78.268-32.16-15.201-62.726-22.125-98.286-22.291-34.613 1.060-64.168 9.273-94.376 26.183-40.154 22.007-70.431 48.717-97.23 85.848-14.327 19.816-24.644 38.223-34.095 60.776-8.852 21.861-14.864 41.224-19.913 64.275-7.919 40.284-10.022 75.73-6.927 116.656 3.252 47.484 14.313 87.725 35.794 130.18 15.406 28.811 33.806 50.82 59.401 71.1 16.261 12.479 31.61 21.374 50.506 29.298 16.982 7.389 32.531 11.503 50.957 13.424 35.938 3.595 68.217-5.293 97.214-26.836-7.935 42.578-17.449 78.557-31.642 119.514-7.050 19.44-14.37 35.64-24.328 53.762-6.144 11.025-12.115 20.064-19.85 30.021-14.975 19.966-32.24 33.869-54.925 44.262-11.282 4.515-21.422 7.257-33.442 9.020l-37.922 3.67 22.066 88.521c19.030 4.344 35.612 6.856 55.062 8.39 13.938 0.291 25.88-0.526 39.636-2.687 33.619-6.262 61.344-17.868 89.413-37.36 34.83-24.726 61.265-50.777 86.478-85.231z",
        "M319.964 497.075c-10.411 2.844-20.46 1.44-29.694-4.153-8.938-6.31-15.091-13.929-19.374-23.998-6.463-15.112-10.297-28.804-12.593-45.065-3.202-23.811-4.694-44.346-4.972-68.351l0.407-51.821 1.302-39.137c1.577-28.476 5.216-52.756 12.035-80.466 3.42-13.383 8.486-24.342 16.443-35.635 6.292-7.826 15.098-11.89 25.143-11.546 13.303-0.951 25.068 2.198 36.134 9.671 12.022 9.191 20.262 19.918 26.019 33.929 8.754 22.387 13.715 42.585 16.366 66.487 3.871 35.455 5.871 65.939 6.656 101.606-0.089 22.137-1.8 41.099-5.687 62.878-3.042 15.551-7.452 28.535-14.463 42.733-10.964 22.316-29.509 37.153-53.721 42.869zM544.923 511.8l8.062-82.343 1.293-46.119c-0.353-34.14-2.829-63.351-8.201-97.068-6.208-34.755-15.267-63.891-29.965-96.003-12.545-27.125-26.904-48.742-47.002-70.868-21.577-22.364-43.536-38.22-71.525-51.653-27.257-12.937-53-19.135-83.149-20.016-24.626-0.3-45.857 3.934-68.499 13.665-28.49 13.034-51.198 28.051-74.288 49.236-24.123 22.797-41.504 45.889-56.707 75.394-15.114 30.24-24.232 58.074-29.93 91.375-6.158 39.881-6.934 74.777-2.53 114.893 4.292 38.047 13.945 70.058 31.398 104.132 14.407 27.013 31.871 47.514 56.22 66.053 15.053 10.691 28.988 18.391 46.062 25.397 14.607 5.641 27.832 8.784 43.445 10.249 23.152 1.534 43.502-3.031 63.775-14.334 26.665-16.25 46.38-35.528 63.204-61.825l-12.593 79.649-15.861 69.728c-8.365 30.797-17.556 56.655-30.531 85.829-9.43 19.975-19.158 36.35-32.197 54.19-9.464 12.229-18.719 21.839-30.597 31.744-25.495 20.612-53.25 31.268-86 33.018l11.637 46.524c42.034 10.122 81.424 5.844 120.32-12.993 16.803-8.347 30.481-16.944 45.247-28.49 20.541-16.955 36.812-33.073 53.953-53.462 35.321-44.69 60.589-86.99 83.222-139.269 26.271-59.060 41.979-112.72 51.737-176.633z"
      ],
      "attrs": [
        {
          "fill": "rgb(0, 0, 0)"
        },
        {
          "fill": "rgb(142, 117, 52)"
        },
        {
          "fill": "rgb(255, 255, 255)"
        }
      ],
      "width": 683,
      "isMulticolor": true,
      "isMulticolor2": false,
      "grid": 0,
      "tags": [
        "bills_away_9"
      ],
      "colorPermutations": {
        "11421175212552552551": [
          {
            "f": 0
          },
          {
            "f": 1
          },
          {
            "f": 2
          }
        ]
      }
    }
  ],
  "colorThemes": [
    [
      [
        0,
        0,
        0,
        1
      ],
      [
        142,
        117,
        52,
        1
      ],
      [
        255,
        255,
        255,
        1
      ]
    ]
  ],
  "colorThemeIdx": 0,
  "preferences": {
    "showGlyphs": true,
    "showQuickUse": true,
    "showQuickUse2": true,
    "showSVGs": true,
    "fontPref": {
      "prefix": "icon-",
      "metadata": {
        "fontFamily": "icomoon"
      },
      "metrics": {
        "emSize": 1024,
        "baseline": 6.25,
        "whitespace": 50
      },
      "embed": false
    },
    "imagePref": {
      "prefix": "icon-",
      "png": true,
      "useClassSelector": true,
      "color": 0,
      "bgColor": 16777215,
      "classSelector": ".icon"
    },
    "historySize": 100,
    "showCodes": true,
    "gridSize": 16
  },
  "IcoMoonType": "icon-set"
}



//console.log(paper);

var font = {
  "0": "nflicon-bills_away_0",
  "1": "nflicon-bills_away_1",
  "2": "nflicon-bills_away_2",
  "3": "nflicon-bills_away_3",
  "4": "nflicon-bills_away_4",
  "5": "nflicon-bills_away_5",
  "6": "nflicon-bills_away_6",
  "7": "nflicon-bills_away_7",
  "8": "nflicon-bills_away_8",
  "9": "nflicon-bills_away_9",
  "A": "nflicon-bills_away_a",
  "B": "nflicon-bills_away_b",
  "C": "nflicon-bills_away_c",
  "D": "nflicon-bills_away_d",
  "E": "nflicon-bills_away_e",
  "F": "nflicon-bills_away_f",
  "G": "nflicon-bills_away_g",
  "H": "nflicon-bills_away_h",
  "I": "nflicon-bills_away_i",
  "J": "nflicon-bills_away_j",
  "K": "nflicon-bills_away_k",
  "L": "nflicon-bills_away_l",
  "M": "nflicon-bills_away_m",
  "N": "nflicon-bills_away_n",
  "O": "nflicon-bills_away_o",
  "P": "nflicon-bills_away_p",
  "Q": "nflicon-bills_away_q",
  "R": "nflicon-bills_away_r",
  "S": "nflicon-bills_away_s",
  "T": "nflicon-bills_away_t",
  "U": "nflicon-bills_away_u",
  "V": "nflicon-bills_away_v",
  "W": "nflicon-bills_away_w",
  "X": "nflicon-bills_away_x",
  "Y": "nflicon-bills_away_y",
  "Z": "nflicon-bills_away_z",
  ",": "nflicon-bills_away_comma",
  "-": "nflicon-bills_away_dash",
  ".": "nflicon-bills_away_period",
  "captain_c": "nflicon-bills_away_small_c",
  "captain_e": "nflicon-bills_away_small_e"
}



    var font = {
  "0": "M156.601,107.333c2.613,11.673,4.14,21.824,5.073,33.74l1.477,30.659l0.47,38.322v38.291l-1.368,30.584 c-0.772,15.877-2.873,29.423-6.945,44.809c-1.484,4.919-3.306,8.968-6.013,13.345c-1.416,2.192-3.125,3.778-5.438,5.04 c-2.72-11.695-4.348-21.866-5.401-33.817l-1.622-34.312l-0.433-29.09l0.146-37.687l0.215-8.586l2.123-36.048 c1.262-12.544,3.063-23.217,6.018-35.484c1.244-4.489,2.697-8.23,4.821-12.384C151.144,111.42,153.395,109.011,156.601,107.333z M250.678,365.04c5.099-11.304,8.8-21.269,12.316-33.142l7.018-27.674l4.577-28.314l1.508-19.658 c0.671-16.085,0.507-29.886-0.544-45.951l-2.337-26.148c-2.802-20.019-7.037-36.923-14.01-55.921 c-6.737-18.532-14.455-33.738-25.452-50.171l-6.371-8.307c-4.599-5.757-8.958-10.365-14.474-15.285 c-4.188-5.662-7.992-10.346-12.674-15.614c-3.313-3.445-6.285-6.272-9.899-9.403c-10.805-9.2-22.159-14.779-36.114-17.745 c-12.699-2.239-24.097-1.56-36.435,2.167c-20.994,8.897-36.941,21.456-50.371,39.672c-6.678,9.175-11.767,17.491-16.887,27.602 c-7.613,15.811-12.739,30.012-16.953,47.014c-8.618,36.298-11.493,68.476-9.438,105.701c1.306,15.884,3.059,29.437,5.838,45.136 c3.735,18.229,8.135,33.597,14.615,51.06c5.479,13.89,11.375,25.33,19.514,37.893c3.135,4.677,6,8.562,9.542,12.952 c4.234,4.904,8.15,8.871,12.992,13.194c3.663,5.383,7.153,9.752,11.6,14.519c7.513,8.086,14.961,14.112,24.478,19.796 c8.09,4.803,15.719,7.791,24.948,9.766c9.711,2.094,18.474,2.063,28.159-0.117c11.513-2.733,20.887-7.2,30.209-14.4 c7.806-6.331,13.938-12.421,20.305-20.157C236.229,390.943,243.584,379.323,250.678,365.04z",
  "1": "200.01,10.354 78.431,10.354 105.581,67.9 105.541,418.413 126.922,439.722 221.568,439.722 221.568,31.479",
  "2": "M213.746,44.445c-5.202-6.709-10.264-11.99-16.751-17.469c-6.819-5.6-13.477-9.427-21.747-12.516 c-8.348-2.917-15.953-4.175-24.794-4.096c-9.271,0.221-17.189,1.581-25.998,4.46c-14.19,4.479-25.501,11.158-36.271,21.425 l-5.646,5.893L38.471,96.784l29.805,40.007l21.238,22.149l15.602-16.141l18.479-17.685c3.415-3.213,7.012-5.282,11.503-6.616 c1.931,4.745,3.127,8.999,3.952,14.053c1.087,6.955,1.717,12.958,2.089,19.987c0.636,19.358-3.631,36.198-13.414,52.914 l-3.697,5.827L33.29,344.716l-0.287,73.477l20.89,21.065l212.843,0.464l0.362-86.916l-21.896-21.965l-71.717-0.22l53.536-69.374 c3.027-3.985,5.458-7.517,8.115-11.755c13.448-22.591,20.975-44.395,24.345-70.455c3.458-26.317,1.639-49.573-5.861-75.026 C246.354,79.585,233.562,60.467,213.746,44.445z",
  "3": "M181.225,423.669c11.98-5.126,21.842-10.46,32.686-17.679c7.135-5.091,12.766-10.109,18.654-16.593 c11.531-13.406,18.477-27.507,22.086-44.811c2.082-10.258,3.1-19.198,3.346-29.66c-0.736-9.137-1.867-16.928-3.744-25.904 c-1.43-5.913-3.023-10.884-5.301-16.52c-3.934-9.126-8.488-16.441-14.943-23.993c-6.057-6.738-11.674-12.122-18.652-17.896 l-8.264-9.272c16.814-12.872,27.895-28.431,34.572-48.528c2.992-9.334,5.014-17.504,6.703-27.163 c0.902-12.653,0.625-23.563-0.938-36.15c-1.998-13.52-6.232-24.771-13.637-36.262c-4.092-6.026-8.111-10.842-13.312-15.945 c-3.926-3.725-7.434-6.757-11.688-10.102c-1.863-2.891-3.717-5.199-6.135-7.647c-4.217-4.136-7.986-7.513-12.553-11.253 c-12.021-7.931-23.543-12.902-37.562-16.202c-13.26-2.317-24.976-2.408-38.278-0.29c-8.589,1.111-15.837,2.949-23.917,6.066 c-6.655,2.241-12.179,4.68-18.328,8.079C59.92,33.112,50.685,41.217,42.004,52.282l24.249,33.263l20.955,20.997 c4.914-3.88,9.302-6.966,14.61-10.284c3.985-2.436,7.766-3.937,12.338-4.903c4.566-0.897,8.731-0.481,13.029,1.296 c1.064,0.438,1.949,0.872,2.955,1.44l1.95,4.657c6.571,18.824,5.39,37.49-3.5,55.34c-3.301,6.77-6.916,12.188-11.907,17.826 c-2.994,2.857-5.824,5.039-9.344,7.214c-4.888,2.889-9.435,4.769-14.931,6.169c-5.865,1.244-10.955,1.986-16.929,2.455 l0.398,36.542l20.639,22.264c7.854,0.051,14.59,0.725,22.295,2.242c4.677,1.119,8.556,2.62,12.77,4.938 c9.249,18.602,12.349,37.054,9.702,57.653c-1.951,11.106-5.266,20.347-10.817,30.158c-5.039,8.521-10.948,14.912-19.052,20.603 c-8.343,5.521-16.488,8.787-26.336,10.568l-6.022,0.872l-30.349,0.9l0.072,44.341l20.391,20.849 c19.942,0.215,37.032-0.468,56.896-2.272C145.875,435.004,162.605,430.83,181.225,423.669z",
  "4": "249.768,329.89 280.137,329.89 280.389,266.188 258.398,244.194 249.768,244.16 249.768,31.944 228.465,10.391 169.088,10.818 19.611,273.275 19.611,307.941 41.203,329.678 137.398,330.071 137.398,417.699 159.348,439.722 249.336,439.722 ",
  "5": "M204.297,390.625c10.604-8.899,18.967-17.387,27.719-28.115c8.365-10.622,14.213-20.776,19.193-33.344 c4.979-13.229,7.348-25.307,7.74-39.429l-0.072-8.74c-1.184-9.241-2.746-17.081-5.193-26.073 c-3.084-10.332-7.381-18.717-13.965-27.251l-6.627-7.852L216.328,203.1c-3.133-4.114-6.088-7.438-9.812-11.034 c-3.646-3.304-6.926-5.963-10.922-8.843c-13.34-9.217-26.279-14.99-42.047-18.762c-3.764-0.782-7.024-1.279-10.848-1.647 l-26.508-0.322l0.251-45.95h109.198l27.074-85.06l-20.918-20.986L45.75,10.314v225.594l20.479,21.089l66.514,0.467 c3.826,8.345,5.354,16.34,4.862,25.5c-0.666,12.259-3.59,22.666-9.381,33.491c-7.681,13.603-15.831,24.387-26.819,35.489 c-8.078,8.048-16.45,13.53-27.046,17.729c-3.901,1.384-7.386,2.204-11.497,2.718c-7.63,0.306-14.185,0.25-21.81-0.175l0.469,45.694 l20.915,21.812l25.857-0.249l16.077-2.213c16.407-3.191,30.168-7.418,45.523-14.008 C170.184,414.082,186.65,404.202,204.297,390.625z",
  "6": "M186.025,435.669c-20.133,6.04-39.289,5.339-58.922-2.173c-11.906-4.766-21.437-10.561-31.155-18.929l-6.171-5.558 c-4.492-4.401-8.156-8.359-12.19-13.188c-6.171-5.056-11.036-9.894-16.11-16.046c-7.003-8.684-12.197-16.785-17.184-26.768 c-6.377-13.334-10.694-25.31-14.288-39.642c-2.758-11.956-4.401-22.36-5.461-34.578l-0.391-24.131 c0.485-16.701,1.753-30.988,4.203-47.521c5.445-32.958,13.7-60.627,27.2-91.183l10.589-21.886l11.441-18.284 c6.696-9.513,12.892-17.324,20.608-26.023c7.779-8.375,15.16-14.877,24.455-21.532c10.522-7.372,20.668-12.122,33.077-15.469 c16.987-4.074,32.692-3.148,49.086,2.88l21.14,20.534l8.837,40.601c-9.603-0.76-17.952-0.074-27.298,2.25 c-8.867,2.506-15.939,6.648-22.463,13.153c-6.009,6.402-10.411,12.605-14.475,20.385c-6.999,14.521-12.083,27.395-16.895,42.782 c22.906-0.2,42.742,6.627,60.67,20.89c5.922,4.894,10.426,9.796,14.796,16.108c5.421,4.376,9.792,8.45,14.542,13.546l5.952,7.166 c7.621,10.613,12.831,20.668,17.112,33.011l3.174,9.628c2.291,9.878,3.81,18.443,5.064,28.514 c1.616,15.952,1.116,29.826-1.643,45.625c-5.094,25.84-14.968,46.994-31.514,67.48 C227.228,416.519,209.175,428.924,186.025,435.669z M143.286,357.814c1.75-0.673,3.058-1.776,4.028-3.378 c1.419-2.304,2.375-4.438,3.175-7.026c2.082-7.518,3.292-14.116,4.027-21.886l1.318-17.998l0.212-36.081l-1.53-24.387 c-5.626,4.202-9.279,9.435-11.299,16.151c-2.837,8.575-4.332,16.233-4.921,25.234C136.803,312.828,138.324,333.907,143.286,357.814 z",
  "7": "161.896,439.08 269.965,31.629 248.614,10.531 30.282,10.278 30.035,110.415 51.601,131.978 141.798,131.978 49.811,417.374 71.448,439.722",
  "8": "M264.651,377.683c-6.655,13.303-14.498,23.651-25.503,33.65c-19.289,16.591-40.535,25.54-65.874,27.75 c-12.886,1.236-24.092,0.695-36.803-1.78c-11.854-2.101-21.756-5.448-32.462-10.972c-9.594-5.308-17.236-10.939-25.15-18.533 c-4.759-4.681-8.581-8.945-12.716-14.181c-5.403-4.003-9.731-7.846-14.33-12.761c-4.328-4.794-7.71-9.208-11.214-14.641 c-8.743-14.521-13.73-28.522-16.141-45.297c-2.169-17.427-1.844-32.653,1.067-49.971C30.273,242.101,44.04,218.777,67,200.678 c-6.85-6.312-12.265-12.209-17.965-19.571c-4.514-6.146-7.649-11.944-10.324-19.081c-2.484-7.123-3.905-13.469-4.681-20.968 c-0.826-8.868-1.162-16.498-1.106-25.399l1.244-11.221c2.646-18.377,8.294-33.7,18.223-49.4 c7.831-11.897,16.751-20.686,28.757-28.363c13.244-8.007,25.995-12.614,41.294-14.933c8.826-1.168,16.465-1.602,25.364-1.424 c9.309,0.892,17.228,2.351,26.254,4.815c12.491,3.697,22.54,9.238,32.329,17.829c6.872,6.333,12.364,12.178,18.259,19.437 c5.631,4.314,10.173,8.394,15.072,13.534c4.542,4.856,8.066,9.354,11.68,14.93c8.02,12.804,12.648,25.228,14.967,40.158 c2.139,14.768,2.139,27.7,0,42.474c-1.446,10.831-4.383,19.914-9.572,29.539c-6.64,11.074-13.752,19.736-23.326,28.404 c18.389,14.79,30.318,32.432,37.189,55.01c3.326,11.268,5.132,21.248,5.958,32.97c0.629,12.206,0.379,22.707-0.817,34.866 C273.337,356.395,269.956,366.519,264.651,377.683z M140.833,357.859c5.688-1.125,10.173-4.214,13.259-9.107 c2.525-3.833,4.244-7.402,5.676-11.754c1.547-5.034,2.592-9.429,3.463-14.615c1.826-13.846,2.114-25.876,0.93-39.79 c-0.605-8.353-2.032-15.435-4.71-23.364c-6.468,2.217-11.239,6.533-14.077,12.748c-3.881,7.929-6.157,15.242-7.464,23.969 c-1.989,13.633-2.454,25.49-1.536,39.229C136.762,343.291,138.12,350.198,140.833,357.859z M143.2,172.567 c4.437-1.458,7.787-4.195,10.104-8.251c2.879-5.033,4.696-9.734,5.929-15.397c4.056-19.452,3.993-36.913-0.215-56.334 c-4.058,0.555-7.349,2.622-9.612,6.031c-3.413,5.233-5.462,10.301-6.642,16.438c-1.749,9.148-2.569,17.118-2.714,26.431 l0.324,12.792C140.726,160.76,141.572,166.277,143.2,172.567z",
  "9": "M186.412,23.723c9.638,5.754,17.323,11.648,25.38,19.458l9.412,10.146c6.048,5.024,10.946,9.687,16.27,15.485l6.787,8.259 c12.715,17.34,20.479,34.579,25.024,55.596c2.216,10.663,3.648,19.883,4.792,30.711l1.541,42.58 c-1.754,31.549-6.419,58.417-15.409,88.704c-9.503,29.743-20.903,54.2-37.583,80.586c-12.434,19.284-26.579,33.621-45.696,46.337 c-8.353,5.419-16.029,9.261-25.375,12.696c-10.816,3.821-20.68,5.486-32.148,5.439c-8.451-0.18-15.678-1.426-23.704-4.082 l-20.667-20.952l-9.902-39.219c10.475,0.122,19.484-1.361,29.351-4.865c8.328-3.187,14.91-7.414,21.276-13.651 c7.175-7.391,12.3-14.72,16.773-23.998c5.976-13.079,10.14-24.738,13.794-38.647c-17.273,0.399-32.243-3.24-47.415-11.54 c-6.924-3.732-12.461-7.695-18.229-13.058c-4.078-3.923-7.15-7.73-10.117-12.545c-7.025-5.13-12.567-10.198-18.305-16.731 c-10.218-12.195-16.726-24.599-20.947-39.939c-4.642-18.529-6.742-34.886-6.933-53.992c-0.006-34.482,10.073-64.245,31.026-91.633 c10.134-12.922,20.877-22.424,34.931-30.926c14.102-8.203,27.85-12.459,44.125-13.657 C153.464,10.108,169.869,14.352,186.412,23.723z M145.26,205.35c5.372-3.547,9.01-8.119,11.265-14.154 c2.831-7.513,4.419-14.281,5.214-22.272c1.066-12.132,1.179-22.595,0.393-34.755c-1.165-14.738-2.871-27.305-5.682-41.831 c-1.785,0.653-3.122,1.788-4.072,3.431c-1.464,2.386-2.42,4.61-3.183,7.297c-2.106,7.877-3.32,14.788-4.011,22.918l-1.247,18.768 l-0.182,37.147L145.26,205.35z",
  "A": "M254.658,439.722l-61.788-0.179l-11.379-67.054l-62.945-0.294l-11.408,67.348H45.342l73.834-429.265h61.555 L254.658,439.722z M171.048,313.016l-21.095-124.688l-21.116,124.402L171.048,313.016z",
  "B": "M208.105,10.278l39.105,42.512v152.001l-19.639,20.635l19.639,18.522v158.966l-34.668,36.807H52.79V10.278 H208.105z M114.328,255.056v120.235h71.115V255.056H114.328z M114.336,192.536h71.115V75.265h-71.115V192.536z",
  "C": "204.47,10.278 95.541,10.278 53.059,54.911 53.043,395.091 94.234,439.722 204.751,439.722 246.955,395.321 246.955,349.222 184.658,349.222 184.548,374.415 115.461,374.562 115.704,75.08 184.316,75.235 184.332,100.529 246.957,100.529 246.957,54.911 ",
  "D": "M205.339,10.278l42.08,44.64l-0.021,340.109l-41.834,44.642l-152.983,0.053V10.364L205.339,10.278z M185.484,374.468V75.476h-70.62v298.992H185.484z",
  "E": "52.671,10.278 52.671,439.722 247.061,439.722 246.99,375.509 114.903,375.509 114.903,265.929 187.959,265.929 188.117,201.001 114.903,201.001 114.918,75.01 247.328,75.01 247.328,10.278",
  "F": "52.797,10.278 52.797,439.722 115.136,439.722 115.136,267.374 188.645,267.374 188.645,202.322 115.136,202.322 115.136,75.126 247.203,75.126 247.203,10.278",
  "G": "94.879,10.278 52.824,54.708 52.801,395.151 95.12,439.722 205.115,439.722 247.183,395.151 247.183,202.043 162.82,202.043 162.82,266.86 185.206,266.86 185.206,374.3 114.778,374.3 114.778,75.25 188.706,75.25 188.583,101.757 247.199,101.757 247.199,54.708 205.129,10.278",
  "H": "52.901,10.278 52.901,439.723 114.764,439.707 114.764,257.15 185.305,257.012 185.305,439.707 247.099,439.707 247.099,10.278 185.305,10.278 185.305,192.477 114.764,192.32 114.764,10.278",
  "I": "118.989,10.316 118.989,439.722 181.011,439.722 181.011,10.278",
  "J": "185.225,10.278 185.225,374.026 115.04,374.026 115.04,337.386 52.567,337.386 52.567,394.687 94.574,439.722 205.428,439.566 247.433,394.854 247.433,10.278",
  "K": "180.395,10.278 114.631,158.117 114.914,10.278 52.801,10.278 52.801,439.606 114.783,439.714 114.838,309.754 136.576,260.354 183.055,439.722 247.199,439.606 175.931,172.942 247.139,10.425",
  "L": "52.803,10.278 52.803,439.722 247.197,439.722 247.197,375.263 114.991,375.263 114.991,10.278",
  "M": "101.906,10.278 40.146,10.278 40.146,439.714 102.184,439.551 102.184,217.271 150.04,372.814 197.887,218.561 197.887,439.722 259.854,439.714 259.854,10.278 197.895,10.278 150.04,176.669",
  "N": "114.781,10.471 52.875,10.471 52.875,439.722 114.757,439.658 114.975,212.318 184.988,439.658 247.125,439.658 247.125,10.278 185.329,10.278 185.393,239.36",
  "O": "M205.039,10.488l42.018,44.197v340.628l-42.395,44.408l-109.376-0.218l-42.343-44.416V54.685l41.335-44.407 L205.039,10.488z M114.833,75.126v299.729h70.271V75.126H114.833z",
  "P": "M205.235,10.278l41.936,44.276l-0.013,156.232l-42.036,44.455l-90.474,0.021v184.458l-61.819-0.147V10.278 H205.235z M114.664,190.915l70.644,0.084V74.738h-70.782L114.664,190.915z",
  "Q": "M240.938,52.146l-0.021,317.912l-22.07,33.216l6.295,15.001l-53.453,21.446l-10.186-28.015l-62.763,0.073 l-39.677-41.579l0.024-318.2l39.66-41.723h102.746L240.938,52.146z M116.923,70.928v280.487h23.624l-5.31-11.918l47.826-20.069 l0.012-248.5H116.923z",
  "R": "M205.207,10.278l42.081,44.556L247.03,206.88l-36.765,43.801l36.736,188.893l-61.552,0.147L147.3,251.396 h-32.341v188.326l-62.247-0.147V10.278H205.207z M114.975,187.062h69.967V72.246h-70.229L114.975,187.062z",
  "S": "94.827,10.442 52.802,52.916 52.802,218.857 95.325,256.664 185.186,256.664 185.186,374.709 114.312,374.866 114.312,352.265 52.794,352.265 52.794,395.306 95.325,439.722 204.935,439.722 247.206,395.15 247.206,236.503 204.942,192.118 114.574,191.955 114.579,75.297 184.687,75.297 184.687,97.734 246.957,97.883 246.957,54.344 204.693,10.278",
  "T": "52.743,10.278 52.897,74.629 118.888,74.629 118.888,439.722 180.803,439.638 180.803,74.629 247.258,74.629 247.246,10.278",
  "U": "52.802,10.278 52.802,394.702 95.344,439.722 204.562,439.722 247.198,394.833 247.198,10.286 185.489,10.286 185.489,377.724 115.101,377.724 115.101,10.278",
  "V": "52.708,10.278 119.222,439.722 181.105,439.722 247.291,10.512 185.574,10.512 150.277,231.012 115.338,10.512",
  "W": "35.263,10.278 61.302,439.722 123.52,439.722 150.109,316.928 176.174,439.722 238.39,439.401 264.737,10.427 202.512,10.278 190.128,205.188 149.876,13.02 109.243,205.367 97.757,10.278",
  "X": "52.833,10.435 118.761,224.464 52.93,439.543 115.017,439.722 149.872,335.04 185.161,439.574 246.868,439.543 181.21,225.07 247.167,10.442 185.186,10.278 150.105,115.566 114.272,10.278",
  "Y": "52.627,10.527 119.057,304.706 119.057,439.722 181.209,439.722 181.209,304.706 247.373,10.278 186.073,10.411 150.348,156.913 114.633,10.411",
  "Z": "52.844,10.278 52.581,75.43 179.357,75.624 52.906,374.51 52.906,439.722 247.419,439.722 247.419,374.305 120.002,374.478 247.408,75.43 247.246,10.278"
}

// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
var font_size = 25,
    panel_Hor_Adjustment = 2,
    font_Top_Adjustment = -22.5,
    tracking = 3,
    middleSpreadAdjustment = {
        left: 1,
        right: 1
    },
    small_Caps_Adjustment = {
        vertical: 0,
        horizontal: 0,
        scale_width: 0, // this effects with the numbers
        scale_height: 0, // this effects with the numbers
    },
    colors = {
        characters: {
            home: [
                "#FFFFFF", // white
                "#C83803"  //red
            ],
            away: [
                "#0B162A", // blue
                "#C83803" //red
            ]
        },
        numbers: {
            home: [
                "#FFFFFF", // white
                "#C83803"  //red
            ],
            away: [
                "#0B162A", // blue
                "#C83803" //red
            ]
        }
    },
    outlines = {
        characters: {
            width: 3
        },
        numbers: {
            width: 3
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: -20, // this moves it up from the bottom
            horizontal: 0,
            scale_width: 9,
            scale_height: 9,
        },
        hyphen: {
            vertical: -8,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: -0.75, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    },
    number_Adjustments = {
        top: 19,
        left: -7,
        width: 75,
        height: 60,
        middle_Space: 5,
        oneOffset: 6
    };






var nflfont = {
  "0": "nflicon-bills_away_0",
  "1": "nflicon-bills_away_1",
  "2": "nflicon-bills_away_2",
  "3": "nflicon-bills_away_3",
  "4": "nflicon-bills_away_4",
  "5": "nflicon-bills_away_5",
  "6": "nflicon-bills_away_6",
  "7": "nflicon-bills_away_7",
  "8": "nflicon-bills_away_8",
  "9": "nflicon-bills_away_9",
  "a": "nflicon-bills_away_a",
  "b": "nflicon-bills_away_b",
  "c": "nflicon-bills_away_c",
  "d": "nflicon-bills_away_d",
  "e": "nflicon-bills_away_e",
  "f": "nflicon-bills_away_f",
  "g": "nflicon-bills_away_g",
  "h": "nflicon-bills_away_h",
  "i": "nflicon-bills_away_i",
  "j": "nflicon-bills_away_j",
  "k": "nflicon-bills_away_k",
  "l": "nflicon-bills_away_l",
  "m": "nflicon-bills_away_m",
  "n": "nflicon-bills_away_n",
  "o": "nflicon-bills_away_o",
  "p": "nflicon-bills_away_p",
  "q": "nflicon-bills_away_q",
  "r": "nflicon-bills_away_r",
  "s": "nflicon-bills_away_s",
  "t": "nflicon-bills_away_t",
  "u": "nflicon-bills_away_u",
  "v": "nflicon-bills_away_v",
  "w": "nflicon-bills_away_w",
  "x": "nflicon-bills_away_x",
  "y": "nflicon-bills_away_y",
  "z": "nflicon-bills_away_z",
  "captain_c": "nflicon-bills_away_small_c"
}